import { useState } from 'react';
import {
  sendLoginOtp,
  verifyLoginOtp,
} from '../auth/phirtiAuth';
import { userFacingErrorMessage } from '../lib/userFacingError';

export function LoginPage() {
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState<'phone' | 'otp'>('phone');
  const [verificationId, setVerificationId] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const dial = '+91';

  async function onSend() {
    setErr(null);
    const digits = phone.replace(/\D/g, '');
    if (digits.length !== 10) {
      setErr('Enter a valid 10-digit Indian mobile number');
      return;
    }
    setBusy(true);
    try {
      const vid = await sendLoginOtp(`${dial}${digits}`);
      setVerificationId(vid);
      setStep('otp');
    } catch (e: unknown) {
      setErr(userFacingErrorMessage(e, { fallback: 'Sign-in failed. Please try again.' }));
    } finally {
      setBusy(false);
    }
  }

  async function onVerify() {
    setErr(null);
    if (otp.trim().length < 4) {
      setErr('Enter the OTP');
      return;
    }
    setBusy(true);
    try {
      await verifyLoginOtp(verificationId, otp.trim());
    } catch (e: unknown) {
      setErr(userFacingErrorMessage(e, { fallback: 'Sign-in failed. Please try again.' }));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-screen">
    <div
      style={{
        minHeight: '100%',
        background: 'linear-gradient(180deg, #e8f2ff 0%, #f5f7fb 40%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: '#fff',
          borderRadius: 16,
          padding: 28,
          boxShadow: '0 8px 40px rgba(0,50,120,0.08)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <img
            src="/phirti-logo.png"
            alt="Phirti"
            width={96}
            height={96}
            style={{ borderRadius: 20, objectFit: 'cover' }}
          />
        </div>
        <h1 style={{ textAlign: 'center', fontSize: 22, margin: '12px 0 4px' }}>
          Phirti
        </h1>
        <p style={{ textAlign: 'center', color: 'var(--ph-muted)', marginBottom: 24 }}>
          Sign in with your mobile number
        </p>

        {step === 'phone' ? (
          <>
            <label style={{ fontSize: 13, color: 'var(--ph-muted)' }}>Country</label>
            <input
              className="ph-input"
              style={{ marginBottom: 12 }}
              value="India (+91)"
              readOnly
              aria-readonly="true"
            />
            <label style={{ fontSize: 13, color: 'var(--ph-muted)' }}>Mobile number</label>
            <input
              className="ph-input"
              style={{ marginBottom: 8 }}
              inputMode="numeric"
              autoComplete="tel"
              placeholder="9876543210"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {err && (
              <p style={{ color: '#c00', fontSize: 14, margin: '8px 0' }}>{err}</p>
            )}
            <button
              type="button"
              className="ph-btn"
              style={{ width: '100%', marginTop: 8 }}
              disabled={busy}
              onClick={() => void onSend()}
            >
              {busy ? 'Sending…' : 'Continue'}
            </button>
          </>
        ) : (
          <>
            <p style={{ fontSize: 14, color: 'var(--ph-muted)', marginBottom: 12 }}>
              Enter the OTP sent to {dial} ••••{phone.slice(-3)}
            </p>
            <input
              className="ph-input"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            {err && (
              <p style={{ color: '#c00', fontSize: 14, margin: '8px 0' }}>{err}</p>
            )}
            <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
              <button
                type="button"
                className="ph-btn-ghost"
                onClick={() => {
                  setStep('phone');
                  setOtp('');
                  setErr(null);
                }}
              >
                Back
              </button>
              <button
                type="button"
                className="ph-btn"
                style={{ flex: 1 }}
                disabled={busy}
                onClick={() => void onVerify()}
              >
                {busy ? 'Verifying…' : 'Verify'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
    </div>
  );
}
